import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import OfferingModal from './OfferingModal';
import CategoryModal from './CategoryModal';
// import decryptUserCookie from './utils/decryptUserCookie';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { getDecryptedUserFromCookie } from './utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, FolderTree, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import EmptyStateBlock from './EmptyStateBlock';
import { useSearch } from '../SearchContext';
import Loader from './Loader';
import { decryptToken } from './utils/getToken';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";



const Category = () => {
    const { globalSearch } = useSearch();
    const [searchQuery, setSearchQuery] = useState('');
    // const userDetails = decryptUserCookie();
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState(categories);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const userData = getDecryptedUserFromCookie("gta_mainstateuser");
    const urlmain = API_BASE_URL
    const [load, setLoad] = useState(false);
    let main_id = "12345"
    const token = decryptToken("accessToken") || ""
    

    const fetchCategories = async () => {
        setLoad(true);
        try {
            const response = await fetch(
                `${urlmain}/category/getdata/category/${userData.main_id}`,
                { method: "GET" }
            );
            const res = await response.json();

            const sortedCategories = Array.isArray(res)
                ? res.sort((a, b) => a.position - b.position)
                : [];

            setCategories(sortedCategories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoad(false);
        }
    };


    useEffect(() => {
        fetchCategories();
    }, [])


    useEffect(() => {
        const filtered = categories.filter((category) =>
            Object.values(category).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredCategories(filtered);
        setCurrentPage(1);
    }, [globalSearch, categories]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
    const currentData = filteredCategories.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    // const toggleStatus = (index) => {
    //     const updatedCategories = [...categories];
    //     updatedCategories[index].status = !updatedCategories[index].status;
    //     setCategories(updatedCategories);
    // };

    const toggleStatus = async (userId) => {
        try {
            const response = await fetch(`${urlmain}/category/toggle-status/${userId}`, {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const result = await response.json();

            if (!result.isError) {
                const updated = categories.map(cat =>
                    cat.id === parseInt(userId) ? { ...cat, status: result.status } : cat
                );
                setCategories(updated);
                toast.success(result.message);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error("Toggle failed");
        }
    };


    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${urlmain}/category/delete-category/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const res = await response.json();

                if (response.ok) {
                    setCategories(prev => prev.filter(cat => cat.id !== id));
                    Swal.fire('Deleted!', 'Category has been deleted.', 'success');
                } else {
                    Swal.fire('Error', res.message || 'Delete failed', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'Something went wrong while deleting.', 'error');
            }
        }
    };


    const handleSave = async (data) => {
       
        try {
            const method = data.id ? "PUT" : "POST";
            const url = data.id
                ? `${urlmain}/category/update/${data.id}`
                : `${urlmain}/category/addcategory/admin1997`;

            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(data),
            });
            const res = await response.json();

            if (response.ok) {
                if (data.id) {
                    setCategories(prev => prev.map(cat => cat.id === data.id ? data : cat));
                    toast.success("Category updated");
                } else {
                    setCategories(prev => [...prev, res]);
                    toast.success("Category added");
                }
            } else {
                toast.error(res.message || "Save failed");
            }
        } catch (error) {
            toast.error("Save error");
        } 
    };


    if (load) {
        return (
            <Loader />
        );
    }




    return (
        <>

            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Category</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setSelectedCategory(null)
                    }}>
                        Add category
                    </button>
                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

                {/* Customer Table */}
                {/* Customer Table */}
                <div className="customer-table responsive-table">
                    <DragDropContext
                        onDragEnd={async (result) => {
                            const { destination, source } = result;
                            if (!destination || destination.index === source.index) return;

                            const reordered = Array.from(categories);
                            const [movedItem] = reordered.splice(source.index, 1);
                            reordered.splice(destination.index, 0, movedItem);

                            const updatedOrder = reordered.map((cat, index) => ({
                                id: cat.id,
                                position: index + 1,
                            }));

                            setCategories(reordered);

                            try {
                                const res = await fetch(`${urlmain}/category/update-order/drag`, {
                                    method: "PUT",
                                    headers: { "Content-Type": "application/json" },
                                    body: JSON.stringify({ updatedOrder }),
                                });
                                const data = await res.json();
                                if (res.ok) {
                                    toast.success(data.message);
                                    fetchCategories();
                                }
                                else toast.error(data.message);
                            } catch (err) {
                                console.error(err);
                                toast.error("Failed to update order");
                            }
                        }}
                    >
                        <Droppable droppableId="categories">
                            {(provided) => (
                                <table className="table" {...provided.droppableProps} ref={provided.innerRef}>
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Position</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.length > 0 ? (
                                            currentData.map((cat, index) => (
                                                <Draggable key={cat?.id?.toString()} draggableId={cat?.id?.toString()} index={index}>
                                                    {(provided, snapshot) => (
                                                        <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={snapshot.isDragging ? "dragging-row" : ""}
                                                            style={{
                                                                ...provided.draggableProps.style,
                                                                background: snapshot.isDragging ? "#f0f8ff" : "white",
                                                            }}
                                                        >
                                                            <td>{cat.category}</td>
                                                            <td>{cat.position}</td>
                                                            <td>
                                                                <button
                                                                    className={`status-toggle ${cat.status === "Active" ? "Active" : "Inactive"}`}
                                                                    onClick={() => toggleStatus(cat.id)}
                                                                >
                                                                    {cat.status === "Active" ? (
                                                                        <i className="fas fa-toggle-on"></i>
                                                                    ) : (
                                                                        <i className="fas fa-toggle-off"></i>
                                                                    )}
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="edit-button"
                                                                    onClick={() => {
                                                                        setSelectedCategory(cat);
                                                                        setIsModalOpen(true);
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-pencil edit-oms"></i>
                                                                </button>
                                                                <button
                                                                    className="delete-button"
                                                                    onClick={() => handleDelete(cat.id)}
                                                                >
                                                                    <i className="fa-solid fa-trash delete-oms"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </Draggable>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="p-4 align-middle">
                                                    <EmptyStateBlock
                                                        compact
                                                        Icon={FolderTree}
                                                        title="No category found"
                                                        description={
                                                            categories.length === 0
                                                                ? 'You have not created any categories yet. Add a category to organize your products.'
                                                                : 'No categories match your search. Try different keywords or clear the search.'
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                        {provided.placeholder}
                                    </tbody>
                                </table>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>



                {/* ✅ MOBILE DRAG & DROP SECTION */}
                <DragDropContext
                    onDragEnd={async (result) => {
                        const { destination, source } = result;
                        if (!destination || destination.index === source.index) return;

                        const reordered = Array.from(categories);
                        const [movedItem] = reordered.splice(source.index, 1);
                        reordered.splice(destination.index, 0, movedItem);

                        const updatedOrder = reordered.map((cat, index) => ({
                            id: cat.id,
                            position: index + 1,
                        }));

                        setCategories(reordered);

                        try {
                            const res = await fetch(`${urlmain}/category/update-order/drag`, {
                                method: "PUT",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ updatedOrder }),
                            });
                            const data = await res.json();
                            if (res.ok) {
                                toast.success(data.message);
                                fetchCategories();
                            } else toast.error(data.message);
                        } catch (err) {
                            console.error(err);
                            toast.error("Failed to update order");
                        }
                    }}
                >
                    <Droppable droppableId="mobileCategories">
                        {(provided) => (
                            <div
                                className="ecom-responsive-cards"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {currentData.length === 0 ? (
                                    <EmptyStateBlock
                                        Icon={FolderTree}
                                        title="No category found"
                                        description={
                                            categories.length === 0
                                                ? 'You have not created any categories yet. Add a category to organize your products.'
                                                : 'No categories match your search. Try different keywords or clear the search.'
                                        }
                                    />
                                ) : (
                                    currentData.map((group, index) => (
                                        <Draggable
                                            key={`cat-${group?.id ?? index}`}
                                            draggableId={`cat-${group?.id ?? index}`}

                                            index={index}
                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    className={`ecom-responsive-card ${snapshot.isDragging ? "dragging-row" : ""}`}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{
                                                        ...provided.draggableProps.style,
                                                        background: snapshot.isDragging
                                                            ? "#f0f8ff"
                                                            : "white",
                                                        boxShadow: snapshot.isDragging
                                                            ? "0px 4px 8px rgba(0,0,0,0.2)"
                                                            : "none",
                                                        borderRadius: "10px",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                >
                                                    <div className="ecom-responsive-header">
                                                        <div className="p-toggle">
                                                            <p
                                                                onClick={() => {
                                                                    setSelectedCategory(group);
                                                                    setIsModalOpen(true);
                                                                }}
                                                            >
                                                                <Pencil
                                                                    size={20}
                                                                    style={{ marginRight: 4 }}
                                                                />{" "}
                                                                <span>Edit</span>
                                                            </p>

                                                            <button
                                                                className={`status-toggle ${group.status === "Active"
                                                                    ? "Active"
                                                                    : "Inactive"
                                                                    }`}
                                                                onClick={() =>
                                                                    toggleStatus(
                                                                        group.id,
                                                                        group.status
                                                                    )
                                                                }
                                                            >
                                                                {group.status === "Active" ? (
                                                                    <>
                                                                        <LucideToggleRight
                                                                            style={{
                                                                                marginRight: 4,
                                                                            }}
                                                                        />
                                                                        <span>Active</span>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <LucideToggleLeft
                                                                            style={{
                                                                                marginRight: 4,
                                                                            }}
                                                                        />
                                                                        <span>Inactive</span>
                                                                    </>
                                                                )}
                                                            </button>
                                                        </div>

                                                        <p onClick={() => handleDelete(group.id)}>
                                                            <Trash2
                                                                size={20}
                                                                style={{ marginRight: 4 }}
                                                            />{" "}
                                                            <span>Delete</span>
                                                        </p>
                                                    </div>

                                                    <div className="ecom-responsive-body">
                                                        <div className="ecom-responsive-left">
                                                            <div className="ecom-image-heading-left">
                                                                <img
                                                                    src={group.icon}
                                                                    alt=""
                                                                    style={{
                                                                        width: "50px",
                                                                        height: "50px",
                                                                        borderRadius: "50%",
                                                                    }}
                                                                />
                                                                <span>
                                                                    <h2>
                                                                        {group.category ||
                                                                            "Not Provided"}
                                                                    </h2>
                                                                    <p>
                                                                        Position:{" "}
                                                                        {group.position}
                                                                    </p>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))
                                )}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>


                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}

            </div>

            <CategoryModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                onSave={handleSave}
                categories={categories}
                setCategories={setCategories}
                fetchCategories={fetchCategories}
            />

        </>
    );
};

export default Category;
